import { Permissions } from "../interfaces/PermissionsInterface";
import { Role } from "../interfaces/RoleInterface";

export const reservationRoles = (
  viewReservation: boolean,
  createReservation: boolean,
  adminReservation: boolean,
  edit_third_party_reservation: boolean,
  unlimitedReservation: boolean,
  shareReservation: boolean,
  manageAttributesReport: boolean,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "View Module",
      value: viewReservation,
      name: "viewReservation",
      helperText: "User can see the reservation module",
      disabled: companyPermissions
        ? !companyPermissions?.reservation_module?.view_module
        : false,
    },
    {
      label: "Create Reservation",
      value: createReservation,
      name: "createReservation",
      helperText:
        "User can create, edit and delete own reservation. Required if 'Reservation Admin' on",
      disabled:
        (companyPermissions
          ? !companyPermissions?.reservation_module?.create_reservation
          : false) || !viewReservation,
    },
    {
      label: "Edit reservations from other users",
      value: edit_third_party_reservation,
      name: "edit_third_party_reservation",
      helperText: "Edit reservations from other users",
      disabled:
        (companyPermissions
          ? !companyPermissions?.reservation_module
              ?.edit_third_party_reservation
          : false) || !viewReservation,
    },
    {
      label: "Reservation Admin",
      value: adminReservation,
      name: "adminReservation",
      helperText: "User can interrupt reservations",
      disabled:
        (companyPermissions
          ? !companyPermissions?.reservation_module?.edit_reservation
          : false) || !viewReservation,
    },
    {
      label: "Unlimited reservation time",
      value: unlimitedReservation,
      name: "unlimitedReservation",
      helperText: "User can create reservations with no period limitations",
      disabled:
        (companyPermissions
          ? !companyPermissions?.reservation_module?.unlimited_reservation
          : false) || !viewReservation,
    },
    {
      label: "Share Reservation",
      value: shareReservation,
      name: "shareReservation",
      helperText: "User can share reservations with other drivers",
      disabled:
        (companyPermissions
          ? !companyPermissions?.reservation_module?.share_reservation
          : false) || !viewReservation,
    },
    {
      label: "Manage Attributes Report",
      value: manageAttributesReport,
      name: "manageAttributesReport",
      helperText: "User can manage the attributes report",
      disabled:
        (companyPermissions
          ? !companyPermissions?.reservation_module?.manage_attributes_report
          : false) || !viewReservation,
    },
  ];
};

export const driverRoles = (
  viewDriver,
  createDriver,
  editDriver,
  deleteDriver,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "View Module",
      value: viewDriver,
      name: "viewDriver",
      helperText: "User can see the driver module",
      disabled: companyPermissions
        ? !companyPermissions?.drivers_module?.view_module
        : false,
    },
    {
      label: "Create Driver",
      value: createDriver,
      name: "createDriver",
      helperText: "User can create drivers",
      disabled:
        (companyPermissions
          ? !companyPermissions?.drivers_module?.create_driver
          : false) || !viewDriver,
    },
    {
      label: "Edit Driver",
      value: editDriver,
      name: "editDriver",
      helperText: "User can edit drivers",
      disabled:
        (companyPermissions
          ? !companyPermissions?.drivers_module?.edit_driver
          : false) || !viewDriver,
    },
    {
      label: "Delete Driver",
      value: deleteDriver,
      name: "deleteDriver",
      helperText: "User can delete drivers",
      disabled:
        (companyPermissions
          ? !companyPermissions?.drivers_module?.delete_driver
          : false) || !viewDriver,
    },
  ];
};

export const vehiclesRoles = (
  getVehicles,
  getVehicleGroups,
  viewHistory,
  viewHistoryParams,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "Get Vehicles",
      value: getVehicles,
      name: "getVehicles",
      helperText: "User can get all vehicles",
      disabled: companyPermissions
        ? !companyPermissions?.vehicles_module?.get_vehicles
        : false,
    },
    {
      label: "Get Vehicle Groups",
      value: getVehicleGroups,
      name: "getVehicleGroups",
      helperText: "User can get vehicle groups",
      disabled: companyPermissions
        ? !companyPermissions?.vehicles_module?.get_vehicle_groups
        : false,
    },
    {
      label: "View History",
      value: viewHistory,
      name: "viewHistory",
      helperText: "User can view historical data of vehicle",
      disabled: companyPermissions
        ? !companyPermissions?.vehicles_module?.view_history
        : false,
    },
    {
      label: "View History Parameters",
      value: viewHistoryParams,
      name: "viewHistoryParams",
      helperText:
        "User can view specific parameters of trips depending on vehicle type",
      disabled: companyPermissions
        ? !companyPermissions?.vehicles_module?.view_history_params
        : false,
    },
  ];
};

export const privateMode = (
  showPrivateData,
  setPrivateVehicles,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "Show Private Data",
      value: showPrivateData,
      name: "showPrivateData",
      helperText: "User can view telemetry data of private vehicles",
      disabled: companyPermissions
        ? !companyPermissions?.vehicles_module?.view_private_telemetry_data
        : false,
    },
    {
      label: "Set Private Vehicles",
      value: setPrivateVehicles,
      name: "setPrivateVehicles",
      helperText: "User can make vehicles' telemetry data private",
      disabled: companyPermissions
        ? !companyPermissions?.vehicles_module?.edit_private_state
        : false,
    },
  ];
};

export const iotKeylessAccessRoles = (
  viewIoTKeylessAccess,
  editIoTKeylessAccess,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "View IoT Keyless Access Module",
      value: viewIoTKeylessAccess,
      name: "viewIoTKeylessAccess",
      helperText: "User can view the IoT Keyless Access Module",
      disabled: companyPermissions
        ? !companyPermissions?.iot_devices_module?.view_module
        : false,
    },
    {
      label: "Edit IoT Keyless Access Module",
      value: editIoTKeylessAccess,
      name: "editIoTKeylessAccess",
      helperText: "User can manage IoT Keyless Access Module",
      disabled: companyPermissions
        ? !companyPermissions?.iot_devices_module?.manage_iot_devices
        : false,
    },
  ];
};

export const keylessAccessMode = (
  keylessAccess: boolean,
  keylessAccessAdmin: boolean,
  giveKeylessAccess: boolean,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "View Keyless Access",
      value: keylessAccess,
      name: "keylessAccess",
      helperText: "User can view Keyless Access Module",
      disabled: companyPermissions
        ? !companyPermissions?.reservation_module?.keyless_access
        : false,
    },
    {
      label: "View Keyless Access Admin",
      value: keylessAccessAdmin,
      name: "keylessAccessAdmin",
      helperText: "Admin User can view Keyless Access Module",
      disabled: companyPermissions
        ? !companyPermissions?.reservation_module?.keyless_access_admin
        : false,
    },
    {
      label: "Give Keyless Access",
      value: giveKeylessAccess,
      name: "giveKeylessAccess",
      helperText: "User can give keyless access to others",
      disabled: companyPermissions
        ? !companyPermissions?.reservation_module?.keyless_access_give_access
        : false,
    },
  ];
};

export const vehicleTypesRoles = (
  viewVehicleTypes,
  createVehicleTypes,
  editVehicleTypes,
  deleteVehicleTypes,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "Get Vehicle Types",
      value: viewVehicleTypes,
      name: "viewVehicleTypes",
      helperText: "User can get vehicle types",
      disabled: companyPermissions
        ? !companyPermissions?.vehicles_module?.get_vehicle_types
        : false,
    },
    {
      label: "Create Vehicle Types",
      value: createVehicleTypes,
      name: "createVehicleTypes",
      helperText: "User can create vehicle types",
      disabled: companyPermissions
        ? !companyPermissions?.vehicles_module?.create_vehicle_type
        : false,
    },
    {
      label: "Edit Vehicle Types",
      value: editVehicleTypes,
      name: "editVehicleTypes",
      helperText: "User can edit vehicle types",
      disabled: companyPermissions
        ? !companyPermissions?.vehicles_module?.edit_vehicle_type
        : false,
    },
    {
      label: "Delete Vehicle Types",
      value: deleteVehicleTypes,
      name: "deleteVehicleTypes",
      helperText: "User delete get vehicle types",
      disabled: companyPermissions
        ? !companyPermissions?.vehicles_module?.delete_vehicle_type
        : false,
    },
  ];
};

export const companyRoles = (
  editCompany,
  viewCompany,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "View Company Settings",
      value: viewCompany,
      name: "viewCompany",
      helperText: "User can see the company settings module",
      disabled: companyPermissions
        ? !companyPermissions?.company_settings_module?.view_module
        : false,
    },
    {
      label: "Edit Company Settings",
      value: editCompany,
      name: "editCompany",
      helperText: "User can edit the company settings",
      disabled: companyPermissions
        ? !companyPermissions?.company_settings_module?.edit_company_settings
        : false,
    },
  ];
};

export const userRoles = (
  createUsers,
  editUsers,
  deleteUsers,
  editRoles,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "Create Users",
      value: createUsers,
      name: "createUsers",
      helperText: "User can create Users",
      disabled:
        (companyPermissions
          ? !companyPermissions?.company_settings_module?.add_user
          : false),
    },
    {
      label: "Edit Users",
      value: editUsers,
      name: "editUsers",
      helperText: "User can edit Users",
      disabled:
        (companyPermissions
          ? !companyPermissions?.company_settings_module?.edit_user
          : false),
    },
    {
      label: "Delete Users",
      value: deleteUsers,
      name: "deleteUsers",
      helperText: "User can delete Users",
      disabled:
        (companyPermissions
          ? !companyPermissions?.company_settings_module?.delete_user
          : false),
    },
    {
      label: "Roles",
      value: editRoles,
      name: "editRoles",
      helperText: "User can maintain the user permissions",
      disabled:
        (companyPermissions
          ? !companyPermissions?.company_settings_module?.edit_role
          : false),
    },
  ];
};

export const fleetRoles = (
  createVehicles,
  editVehicles,
  deleteVehicles,
  editGroups,
  editModels,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "Create Vehicles",
      value: createVehicles,
      name: "createVehicles",
      helperText: "User can create vehicles",
      disabled:
        (companyPermissions
          ? !companyPermissions?.vehicles_module?.create_vehicle
          : false),
    },
    {
      label: "Edit Vehicles",
      value: editVehicles,
      name: "editVehicles",
      helperText: "User can edit vehicles",
      disabled:
        (companyPermissions
          ? !companyPermissions?.vehicles_module?.edit_vehicle
          : false),
    },
    {
      label: "Delete Vehicles",
      value: deleteVehicles,
      name: "deleteVehicles",
      helperText: "User can delete vehicles",
      disabled:
        (companyPermissions
          ? !companyPermissions?.vehicles_module?.delete_vehicle
          : false),
    },
    {
      label: "Groups",
      value: editGroups,
      name: "editGroups",
      helperText: "User can maintain the vehicle groups",
      disabled:
        (companyPermissions
          ? !companyPermissions?.vehicles_module?.edit_vehicle_group
          : false),
    },
    {
      label: "Models",
      value: editModels,
      name: "editModels",
      helperText: "User can maintain the vehicle models",
      disabled:
        (companyPermissions
          ? !companyPermissions?.vehicles_module?.edit_vehicle_model
          : false),
    },
  ];
};

export const diagnosisRoles = (
  viewDiagnosis,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "View Module",
      value: viewDiagnosis,
      name: "viewDiagnosis",
      helperText: "User can view the Technical Status Page",
      disabled: companyPermissions
        ? !companyPermissions?.diagnosis_module?.view_module
        : false,
    },
  ];
};

export const logBookRoles = (viewLogs, createLogs): Role[] => {
  return [
    {
      label: "View Module",
      value: viewLogs,
      name: "viewLogs",
      helperText: "User can view the Logbook module",
    },
    {
      label: "Create Logs",
      value: createLogs,
      name: "createLogs",
      helperText: "User can create own logs",
    },
  ];
};

export const activityRoles = (
  viewActivity,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "View Activitys",
      value: viewActivity,
      name: "viewActivity",
      helperText: "Shows when a vehicle has a ongoing activity",
      disabled: companyPermissions
        ? !companyPermissions?.activity_module?.view_module
        : false,
    },
  ];
};

export const lsvaRoles = (
  viewLSVA,
  manualCorrectLSVA,
  revokeLSVA,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "View LSVA Module",
      value: viewLSVA,
      name: "viewLSVA",
      helperText: "Access to LSVA status and declarations",
      disabled: companyPermissions
        ? !companyPermissions?.lsva_module?.view_module
        : false,
    },
    {
      label: "Create Corrections",
      value: manualCorrectLSVA,
      name: "manualCorrectLSVA",
      helperText: "The user can create manual corrections for LSVA",
      disabled: companyPermissions
        ? !companyPermissions?.lsva_module?.create_manual_corrections
        : false,
    },
    {
      label: "Revoke Corrections",
      value: revokeLSVA,
      name: "revokeLSVA",
      helperText: "The user can revoke manual corrections for LSVA",
      disabled: companyPermissions
        ? !companyPermissions?.lsva_module?.revoke_manual_corrections
        : false,
    },
  ];
};

export const reportingRoles = (
  viewReports,
  reportJobsAdmin,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "View Module",
      value: viewReports,
      name: "viewReports",
      helperText: "",
      disabled: companyPermissions
        ? !companyPermissions?.reporting_module?.view_module
        : false,
    },
    {
      label: "Report Jobs Admin",
      value: reportJobsAdmin,
      name: "reportJobsAdmin",
      helperText: "The user can view, edit, and delete any report job",
      disabled: companyPermissions
        ? !companyPermissions?.reporting_module?.report_jobs_admin
        : false,
    },
  ];
};

export const invoiceRoles = (
  viewInvoice: boolean,
  approveInvoice: boolean,
  releaseInvoice: boolean,
  viewReleaseInvoice: boolean,
  releaseInvoiceDealer: boolean,
  manageReleaseInvoice: boolean,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "View Module",
      value: viewInvoice,
      name: "viewInvoice",
      helperText: "",
      disabled: companyPermissions
        ? !companyPermissions?.invoice_module?.view_module
        : false,
    },
    {
      label: "Approve invoices",
      value: approveInvoice,
      name: "approveInvoice",
      helperText: "The user can view, and approve invoices",
      disabled: companyPermissions
        ? !companyPermissions?.invoice_module?.approve_invoice
        : false,
    },
    {
      label: "Release invoices",
      value: releaseInvoice,
      name: "releaseInvoice",
      helperText: "The user can view, approve, reject and release invoices",
      disabled: companyPermissions
        ? !companyPermissions?.invoice_module?.release_invoice
        : false,
    },
    {
      label: "View release invoices",
      value: viewReleaseInvoice,
      name: "viewReleaseInvoice",
      helperText: "User can view release invoices",
      disabled: companyPermissions
        ? !companyPermissions?.invoice_module?.view_release_invoice
        : false,
    },
    {
      label: "Release invoice dealer",
      value: releaseInvoiceDealer,
      name: "releaseInvoiceDealer",
      helperText: "User can reject invoices and upload/delete QR invoice",
      disabled: companyPermissions
        ? !companyPermissions?.invoice_module?.release_invoice_dealer
        : false,
    },
    {
      label: "Manage release invoices",
      value: manageReleaseInvoice,
      name: "manageReleaseInvoice",
      helperText:
        "User can request, release, delete, reject and re-reject invoices; remove QR invoice",
      disabled: companyPermissions
        ? !companyPermissions?.invoice_module?.manage_release_invoice
        : false,
    },
  ];
};

export const tachoRoles = (
  viewTacho,
  tachoDownload,
  tachoScheduler,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "View Module",
      value: viewTacho,
      name: "viewTacho",
      helperText: "User can see the Tacho Download and Scheduler module",
      disabled: companyPermissions
        ? !companyPermissions?.tacho_module?.view_module
        : false,
    },
    {
      label: "Tacho Download",
      value: tachoDownload,
      name: "tachoDownload",
      helperText: "User can create, edit, and delete tacho download",
      disabled: companyPermissions
        ? !companyPermissions?.tacho_module?.tacho_download
        : false,
    },
    {
      label: "Scheduler",
      value: tachoScheduler,
      name: "tachoScheduler",
      helperText: "User can create, edit, run, stop, and delete scheduler",
      disabled: companyPermissions
        ? !companyPermissions?.tacho_module?.tacho_scheduler
        : false,
    },
  ];
};

export const uiRoles = (
  viewPortalFrontend: boolean,
  sendFeedback: boolean,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "View Frontend",
      value: viewPortalFrontend,
      name: "viewPortalFrontend",
      helperText:
        "User can view Fleet Frontend, otherwise only API access is allowed",
      disabled: companyPermissions
        ? !companyPermissions?.frontend_module?.view_portal
        : false,
    },
    {
      label: "Send feedback",
      value: sendFeedback,
      name: "sendFeedback",
      helperText: "User can send feedback",
      disabled: companyPermissions
        ? !companyPermissions?.frontend_module?.send_feedback
        : false,
    },
  ];
};

export const overviewRoles = (
  viewOverview,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "View Overview Page",
      value: viewOverview,
      name: "viewOverview",
      helperText:
        "Activates the vehicle overview module with parking and active vehicles",
      disabled: companyPermissions
        ? !companyPermissions?.overview_module?.view_module
        : false,
    },
  ];
};

export const fleetPageRoles = (
  viewFleetPage,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "View Fleet page",
      value: viewFleetPage,
      name: "viewFleetPage",
      helperText: "Activate Fleet modul with lists of all vehicles",
      disabled: companyPermissions
        ? !companyPermissions?.fleet_module?.view_module
        : false,
    },
  ];
};

export const incidentsRoles = (
  viewIncidents,
  createIncidents,
  editIncidents,
  deleteIncidents,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "View Module",
      value: viewIncidents,
      name: "viewIncidents",
      helperText: "User can see the incidents module",
      disabled: companyPermissions
        ? !companyPermissions?.incidents_module?.view_module
        : false,
    },
    {
      label: "Create Incidents",
      value: createIncidents,
      name: "createIncidents",
      helperText: "User can report incidents for allowed vehicles",
      disabled: companyPermissions
        ? !companyPermissions?.incidents_module?.create_incident
        : false,
    },
    {
      label: "Edit Incidents",
      value: editIncidents,
      name: "editIncidents",
      helperText: "User can edit incidents",
      disabled: companyPermissions
        ? !companyPermissions?.incidents_module?.edit_incident
        : false,
    },
    {
      label: "Delete Incidents",
      value: deleteIncidents,
      name: "deleteIncidents",
      helperText: "User can delete incidents",
      disabled: companyPermissions
        ? !companyPermissions?.incidents_module?.delete_incident
        : false,
    },
  ];
};

export const tracesRoles = (
  viewRadius,
  viewTraces,
  viewAccurateWidth,
  editVehicleToFollow,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "View Radius",
      value: viewRadius,
      name: "viewRadius",
      helperText: "Radius tab is active for user",
      disabled: companyPermissions
        ? !companyPermissions?.radius_module?.view_module
        : false,
    },
    {
      label: "View Traces",
      value: viewTraces,
      name: "viewTraces",
      helperText: "Traces is active for user",
      disabled: companyPermissions
        ? !companyPermissions?.radius_module?.view_traces
        : false,
    },
    {
      label: "View Accurate Width",
      value: viewAccurateWidth,
      name: "viewAccurateWidth",
      helperText: "Accurate Width is selectable",
      disabled: companyPermissions
        ? !companyPermissions?.radius_module?.view_accurate_width
        : false,
    },
    {
      label: "Edit Vehicle To Follow",
      value: editVehicleToFollow,
      name: "editVehicleToFollow",
      helperText: "Edit which vehicle/s should be followed",
      disabled: companyPermissions
        ? !companyPermissions?.radius_module?.edit_vehicle_to_follow
        : false,
    },
  ];
};

export const dashboardRoles = (
  viewDashboards,
  viewEco,
  viewDriverRanking,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "View Dashboards",
      value: viewDashboards,
      name: "viewDashboards",
      helperText: "Base dashboards are active for user",
      disabled: companyPermissions
        ? !companyPermissions?.dashboard_module?.view_module
        : false,
    },
    {
      label: "View Eco",
      value: viewEco,
      name: "viewEco",
      helperText: "Eco tab is active for user",
      disabled:
        (companyPermissions
          ? !companyPermissions?.dashboard_module?.view_eco
          : false),
    },
    {
      label: "View Driver Ranking",
      value: viewDriverRanking,
      name: "viewDriverRanking",
      helperText: "Driver Ranking tab is active for user",
      disabled:
        (companyPermissions
          ? !companyPermissions?.dashboard_module?.view_driver_ranking
          : false),
    },
  ];
};

export const fleetboxRoles = (
  viewFleetboxModule,
  createFleetbox,
  editFleetbox,
  deleteFleetbox,
  firmwareAdmin,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "View Module",
      value: viewFleetboxModule,
      name: "viewFleetboxModule",
      helperText: "User can see the fleetbox module",
      disabled: companyPermissions
        ? !companyPermissions?.fleetbox_module?.view_module
        : false,
    },
    {
      label: "Create Fleetbox",
      value: createFleetbox,
      name: "createFleetbox",
      helperText: "User can create new fleetboxes",
      disabled: companyPermissions
        ? !companyPermissions?.fleetbox_module?.create_fleetbox
        : false,
    },
    {
      label: "Edit Fleetbox",
      value: editFleetbox,
      name: "editFleetbox",
      helperText: "User can edit fleetboxes",
      disabled: companyPermissions
        ? !companyPermissions?.fleetbox_module?.edit_fleetbox
        : false,
    },
    {
      label: "Delete Fleetbox",
      value: deleteFleetbox,
      name: "deleteFleetbox",
      helperText: "User can delete fleetboxes",
      disabled: companyPermissions
        ? !companyPermissions?.fleetbox_module?.delete_fleetbox
        : false,
    },
    {
      label: "Firmware admin",
      value: firmwareAdmin,
      name: "firmwareAdmin",
      helperText:
        "User can manage firmwares, device configs and upload them to devices",
      disabled: companyPermissions
        ? !companyPermissions?.fleetbox_module?.firmware_admin
        : false,
    },
  ];
};

export const rentalRoles = (
  rentalTariffsAdmin: boolean,
  rentalViewInvoices: boolean,
  rentalEditInvoices: boolean,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "Rental Tariffs Admin",
      value: rentalTariffsAdmin,
      name: "rentalTariffsAdmin",
      helperText: "The user can view, edit, and delete any rental tariff",
      disabled: companyPermissions
        ? !companyPermissions?.rental_module?.rental_tariff_admin
        : false,
    },
    {
      label: "Rental View Invoices",
      value: rentalViewInvoices,
      name: "rentalViewInvoices",
      helperText: "User can view generated rental invoices",
      disabled: companyPermissions
        ? !companyPermissions?.rental_module?.view_invoices
        : false,
    },
    {
      label: "Rental Edit Invoices",
      value: rentalEditInvoices,
      name: "rentalEditInvoices",
      helperText: "User can edit rental invoices",
      disabled: companyPermissions
        ? !companyPermissions?.rental_module?.edit_invoices
        : false,
    },
  ];
};

export const smsRoles = (
  sendSMSCommands: boolean,
  sendSMSCommandsAdmin: boolean,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "Send SMS Commands",
      value: sendSMSCommands,
      name: "sendSMSCommands",
      helperText: "The user can send predefined SMS commands",
      disabled: companyPermissions
        ? !companyPermissions?.fleetbox_module?.send_sms_command
        : false,
    },
    {
      label: "Send SMS Commands Admin",
      value: sendSMSCommandsAdmin,
      name: "sendSMSCommandsAdmin",
      helperText: "The user can send any SMS command",
      disabled: companyPermissions
        ? !companyPermissions?.fleetbox_module?.send_sms_command_admin
        : false,
    },
  ];
};

export const bridgeRoles = (
  sendBridgeCommands: boolean,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "Send Bridge Commands",
      value: sendBridgeCommands,
      name: "sendBridgeCommands",
      helperText: "The user can send predefined Bridge commands",
      disabled: companyPermissions
        ? !companyPermissions?.fleetbox_module?.send_bridge_command
        : false,
    }
  ];
};

export const zonesRoles = (
  viewZones: boolean,
  createZones: boolean,
  editZones: boolean,
  deleteZones: boolean,
  companyPermissions: Permissions | null = null,
): Role[] => {
  return [
    {
      label: "View module",
      value: viewZones,
      name: "viewZones",
      helperText: "User can view zones",
      disabled: companyPermissions
        ? !companyPermissions.geozones_module?.view_module
        : false,
    },
    {
      label: "Create zones",
      value: createZones,
      name: "createZones",
      helperText: "User can create zones",
      disabled: companyPermissions
        ? !companyPermissions.geozones_module?.create_zone
        : false,
    },
    {
      label: "Edit zones",
      value: editZones,
      name: "editZones",
      helperText: "User can edit zones",
      disabled: companyPermissions
        ? !companyPermissions.geozones_module?.edit_zone
        : false,
    },
    {
      label: "Delete zones",
      value: deleteZones,
      name: "deleteZones",
      helperText: "User can delete zones",
      disabled: companyPermissions
        ? !companyPermissions.geozones_module?.delete_zone
        : false,
    },
  ];
};

export const documentsRoles = (
  viewDocuments: boolean,
  manageDocuments: boolean,
  deleteDocuments: boolean,
  manageReservationDocuments: boolean,
  companyPermissions: Permissions | null = null,
): Role[] => {
  return [
    {
      label: "View module",
      value: viewDocuments,
      name: "viewDocuments",
      helperText: "User can view Documents",
      disabled: companyPermissions
        ? !companyPermissions.documents_module?.view_module
        : false,
    },
    {
      label: "Manage documents",
      value: manageDocuments,
      name: "manageDocuments",
      helperText: "User can create, edit, archive and restore Documents",
      disabled:
        (companyPermissions
          ? !companyPermissions.documents_module?.manage_document
          : false) || !viewDocuments,
    },
    {
      label: "Delete documents",
      value: deleteDocuments,
      name: "deleteDocuments",
      helperText: "User can delete documents",
      disabled:
        (companyPermissions
          ? !companyPermissions.documents_module?.delete_document
          : false) || !viewDocuments,
    },
    {
      label: "Manage Documents in Reservations",
      value: manageReservationDocuments,
      name: "manageReservationDocuments",
      helperText: "User can manage documents in Reservation",
      disabled:
        (companyPermissions
          ? !companyPermissions.documents_module?.manage_reservation_document
          : false) || !viewDocuments,
    },
  ];
};

export const customFieldsRoles = (
  customFieldsAdmin: boolean,
  companyPermissions: Permissions | null = null,
): Role[] => {
  return [
    {
      label: "Manage Custom Fields",
      value: customFieldsAdmin,
      name: "customFieldsAdmin",
      helperText: "User can create, edit, archive and delete custom fields",
      disabled: companyPermissions
        ? !companyPermissions.custom_fields_module?.custom_fields_admin
        : false,
    },
  ];
};

export const resourcePlannerRoles = (
  viewResourcePlanner: boolean,
  companyPermissions: Permissions | null = null,
): Role[] => {
  return [
    {
      label: "Manage Resource Planner",
      value: viewResourcePlanner,
      name: "viewResourcePlanner",
      helperText: "User can view and interact with Resource Planner Module",
      disabled: companyPermissions
        ? !companyPermissions.resource_planner_module?.view_module
        : false,
    },
  ];
};

export const contactsRoles = (
  viewContacts: boolean,
  createContacts: boolean,
  editContacts: boolean,
  deleteContacts: boolean,
  companyPermissions: Permissions | null = null,
): Role[] => {
  return [
    {
      label: "View module",
      value: viewContacts,
      name: "viewContacts",
      helperText: "User can view contacts",
      disabled: companyPermissions
        ? !companyPermissions.contacts_module?.view_module
        : false,
    },
    {
      label: "Create contacts",
      value: createContacts,
      name: "createContacts",
      helperText: "User can create contacts",
      disabled:
        (companyPermissions
          ? !companyPermissions.contacts_module?.create_contact
          : false) || !viewContacts,
    },
    {
      label: "Edit contacts",
      value: editContacts,
      name: "editContacts",
      helperText: "User can edit contacts",
      disabled:
        (companyPermissions
          ? !companyPermissions.contacts_module?.edit_contact
          : false) || !viewContacts,
    },
    {
      label: "Delete contacts",
      value: deleteContacts,
      name: "deleteContacts",
      helperText: "User can delete contacts",
      disabled:
        (companyPermissions
          ? !companyPermissions.contacts_module?.delete_contact
          : false) || !viewContacts,
    },
  ];
};

export const searchRoles = (
  viewSearchByAttributes: boolean,
  companyPermissions: Permissions = null,
): Role[] => {
  return [
    {
      label: "Search by attributes",
      value: viewSearchByAttributes,
      name: "viewSearchByAttributes",
      helperText:
        "User can filter vehicles by different attributes in global search",
      disabled: companyPermissions
        ? !companyPermissions?.search_module?.view_search_by_attributes
        : false,
    },
  ];
};

export const tagsRoles = (
  viewTags: boolean,
  createTags: boolean,
  editTags: boolean,
  deleteTags: boolean,
  companyPermissions: Permissions | null = null,
): Role[] => {
  return [
    {
      label: "View module",
      value: viewTags,
      name: "viewTags",
      helperText: "User can view tags",
      disabled: companyPermissions
        ? !companyPermissions.tags_module?.view_module
        : false,
    },
    {
      label: "Create tags",
      value: createTags,
      name: "createTags",
      helperText: "User can create tags",
      disabled:
        (companyPermissions
          ? !companyPermissions.tags_module?.create_tag
          : false) || !viewTags,
    },
    {
      label: "Edit tags",
      value: editTags,
      name: "editTags",
      helperText: "User can edit tags",
      disabled:
        (companyPermissions
          ? !companyPermissions.tags_module?.edit_tag
          : false) || !viewTags,
    },
    {
      label: "Delete tags",
      value: deleteTags,
      name: "deleteTags",
      helperText: "User can delete tags",
      disabled:
        (companyPermissions
          ? !companyPermissions.tags_module?.delete_tag
          : false) || !viewTags,
    },
  ];
};
